/**
 * Whether visitCount is allowed relative to dayCount.
 * Empty either side → true (mutual required handled elsewhere).
 * Both present → visitCount must be <= dayCount.
 * @param {unknown} visitCount
 * @param {unknown} dayCount
 * @returns {boolean}
 */
export function isVisitCountAllowed(visitCount, dayCount) {
  const hasVisit = visitCount !== null && visitCount !== undefined && visitCount !== '';
  const hasDay = dayCount !== null && dayCount !== undefined && dayCount !== '';
  if (!hasVisit || !hasDay) return true;

  const visits = Number(visitCount);
  const days = Number(dayCount);
  if (!Number.isFinite(visits) || !Number.isFinite(days)) return true;

  return visits <= days;
}
